<div id="cover" *ngIf="commonDataObject.isLoad"></div>

<div class="reset-container">
    <div class="reset-card">
        <div class="reset-title">Reset Password</div>
        <form [formGroup]="resetForm" autocomplete="off">
            <div class="form-group">
                <label>Old Password <span class="star">*</span></label>
                <div class="password-wrapper">
                    <input [type]="showOldPassword ? 'text' : 'password'" name="old_password"
                        formControlName="old_password">
                    <i class="fas" [class.fa-eye]="!showOldPassword" [class.fa-eye-slash]="showOldPassword"
                        (click)="togglePassword('oldPassword')"></i>
                </div>
            </div>
            <div class="form-group">
                <label>New Password <span class="star">*</span></label>
                <div class="password-wrapper">
                    <input [type]="showNewPassword ? 'text' : 'password'" name="new_password" (input)="checkPassword()"
                        formControlName="new_password">
                    <i class="fas" [class.fa-eye]="!showNewPassword" [class.fa-eye-slash]="showNewPassword"
                        (click)="togglePassword('newPassword')"></i>
                </div>
            </div>
            <div class="form-group">
                <label>Confirm Password <span class="star">*</span></label>
                <div class="password-wrapper">
                    <input [type]="showConfirmPassword ? 'text' : 'password'" name="confirm_password"
                        (input)="checkPassword()" formControlName="confirm_password">
                    <i class="fas" [class.fa-eye]="!showConfirmPassword" [class.fa-eye-slash]="showConfirmPassword"
                        (click)="togglePassword('confirmPassword')"></i>
                </div>
            </div>
            <div class="error-match" *ngIf="!commonDataObject.isMatch">
                ⚠ New Password and Confirm Password must match.
            </div>
            <button type="submit" class="btn-primary-save" style="min-width: 390px; display: block; justify-items: center;" [disabled]="!commonDataObject.isMatch || resetForm.invalid"
                (click)="resetPW()">
                Submit
            </button>
        </form>
    </div>
</div>

<div class="alert-message" [class.show]="commonDataObject.issuccessAlert || commonDataObject.iserrorAlert"
    [class.success]="commonDataObject.issuccessAlert" [class.error]="commonDataObject.iserrorAlert">
    <i class="fas" [class.fa-check-circle]="commonDataObject.issuccessAlert"
        [class.fa-exclamation-circle]="commonDataObject.iserrorAlert"></i>
    <span>{{ commonDataObject.apiMeassge }}</span>
    <i class="fas fa-times close-alert"
        (click)="commonDataObject.issuccessAlert = false; commonDataObject.iserrorAlert = false"></i>
</div>